<button type="submit" type="button" class="button is-danger ml-3 mr-3" (click)="Clicked($event)" [disabled]="Animate">
    <span class="icon-text">
      <span>Delete</span>
      <span class="icon">
        <i class="fa fa-trash"></i>
      </span>
    </span>
  </button>